import React from 'react'
import MuiPagination from '@mui/material/Pagination'
import Stack from '@mui/material/Stack'

export default function Pagination({ curPage = 1, offset = 10, totalCount = 0, setCurPage }) {
    const totalPage = Math.ceil(Number(totalCount || 0) / Number(offset || 10))

    if (totalPage <= 1) {
        return null
    }

    const page = Math.min(Math.max(Number(curPage || 1), 1), totalPage)

    const handleChange = (_event, value) => {
        setCurPage(value)
    }

    return (
        <Stack spacing={2} sx={{ mt: 2, alignItems: 'center' }}>
            <MuiPagination
                count={totalPage}
                page={page}
                color="primary"
                showFirstButton
                showLastButton
                onChange={handleChange}
            />
        </Stack>
    )
}
